import { render, staticRenderFns } from "./my-bindAuth.vue?vue&type=template&id=6b1ace47&scoped=true"
import script from "./my-bindAuth.vue?vue&type=script&lang=js"
export * from "./my-bindAuth.vue?vue&type=script&lang=js"
import style0 from "./my-bindAuth.vue?vue&type=style&index=0&id=6b1ace47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ace47",
  null
  
)

export default component.exports